import React from 'react';
// import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import ListingImageGalleryNew from './ListingImageGalleryNew/ListingImageGalleryNew';
import css from './ListingPage.module.css';
import { DAMAGE } from '../../util/types';

function moveToFirst(arr, index) {
  if (index > -1 && index < arr.length) {
    const element = arr.splice(index, 1)[0]; // Remove the element at the given index
    arr.unshift(element); // Add the element to the beginning of the array
  }
  return arr;
};

const SectionGallery = props => {
  const { listing, variantPrefix, intl, variants, isPreviewPage, currentUser, isOwnListing } = props;
  const images = listing?.images;
  const { listingImagesUrl = [], heroImageId, otherImages = [], listingVideo = {}, anyDamage } = listing?.attributes?.publicData || {};
  const removeDamage = (!anyDamage?.trim() && otherImages && otherImages.length > 0) ?
    otherImages.filter((e) => e.imageType != DAMAGE) : otherImages;

  const listingVideoArray = (listingVideo?.resource_type == 'video') ? [listingVideo] : [];
  const allImages = [...listingImagesUrl, ...removeDamage, ...listingVideoArray];
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const heroImgIndex = listingImagesUrl?.findIndex(img => img.public_id === heroImageId);
  let updatedUrlsOrder = allImages;
  if (heroImgIndex !== -1) {
    updatedUrlsOrder = moveToFirst(allImages, heroImgIndex)
  };

  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGalleryNew
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        variants={variants}
        isPreviewPage={isPreviewPage}
        listingImagesUrl={updatedUrlsOrder}
        currentUser={currentUser}
        currentListing={listing}
        isOwnListing={isOwnListing}
        intl={intl}
        listingVideo={listingVideo}
      />
    </div>
  );
};

export default SectionGallery;
